/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthReportGenerationRequest
 */
export interface UpdatePalReauthReportGenerationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePalReauthReportGenerationRequest
     */
    overridden_report_text?: string | null;
}

/**
 * Check if a given object implements the UpdatePalReauthReportGenerationRequest interface.
 */
export function instanceOfUpdatePalReauthReportGenerationRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatePalReauthReportGenerationRequestFromJSON(json: any): UpdatePalReauthReportGenerationRequest {
    return UpdatePalReauthReportGenerationRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthReportGenerationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthReportGenerationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'overridden_report_text': !exists(json, 'overridden_report_text') ? undefined : json['overridden_report_text'],
    };
}

export function UpdatePalReauthReportGenerationRequestToJSON(value?: UpdatePalReauthReportGenerationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'overridden_report_text': value.overridden_report_text,
    };
}

